import $ from 'jquery';

export default <T extends any>(url: string, settings?: JQuery.AjaxSettings): Promise<T> => {
	return new Promise((resolve, reject) => {
		$.ajax(url, settings)
			.done(resolve)
			.fail(reject);
	});
};
